import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { getNotificationsOpenedClosed } from '../../api/notificationAPI';

const NotificationsOpenClosedChart = () => {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const stats = await getNotificationsOpenedClosed();
      if (!stats) return;

      const dates = stats.map(item => item.date);
      const openedData = stats.map(item => item.opened);
      const closedData = stats.map(item => item.closed);

      setChartSeries([
        { name: 'Opened', data: openedData },
        { name: 'Closed', data: closedData }
      ]);

      setChartOptions({
        legend: { show: false },
        chart: {
          type: 'line',
          toolbar: { show: false },
        },
        dataLabels: { enabled: false },
        stroke: {
          curve: 'smooth',
          width: 3,
          colors: ['#45B369', '#144BD6'],
        },
        grid: {
          show: true,
          borderColor: '#D1D5DB',
          strokeDashArray: 1,
          xaxis: { lines: { show: false } },
          yaxis: { lines: { show: true } },
        },
        markers: {
          colors: ['#45B369', '#144BD6'],
          strokeWidth: 2,
          size: 0,
          hover: { size: 8 }
        },
        xaxis: { categories: dates, labels: { style: { fontSize: '14px' } } },
        yaxis: { labels: { style: { fontSize: '14px' } } },
      });
    };

    fetchData();
  }, []);

  return (
    <div className="col-xxl-8">
      <div className="card h-100 radius-8 border-0">
        <div className="card-body p-24 mb-8">
          <h6 className="mb-4 fw-bold text-lg">Notifications Opened vs Closed</h6>
          <ReactApexChart options={chartOptions} series={chartSeries} type="line" height={300} width="100%" />
        </div>
      </div>
    </div>
  );
};

export default NotificationsOpenClosedChart;
